module.exports = __webpack_public_path__ + "img/trezor.43f6d510.svg";